import TweenMax from "gsap"
import snowf from 'snowf'
//第一栏动画
var dateimg = $('.date');
TweenMax.from(dateimg,1,{alpha:0,scale:0,ease:Power3.easeOut},'1');

var snow = snowf.init({
    size: 7,
    amount: 200,
    wind:0
});

window.onresize = function(){
  snow.resize();
}





// WEBPACK FOOTER //
// ./src/pages/actives/christmas.js